export type License = {
  userListId: number,
  clientId: number,
  clientCustomerName: string,
  clientProduct: string,
  cost: number,
  currencyCode: string,
  status: string,
};

export const DDP_PRICE_UNIT_SIZE = 1000000;

export const DDP_CLIENT_ID_GOOGLE_RESELLER_CLIENT_ID = 1169866720;

export const DdpClientProduct = {
  RESELLER: 'RESELLER'
} as const;

export const EditableClientProducts = [DdpClientProduct.RESELLER, 'DISPLAY_VIDEO_ADVERTISER', 'DISPLAY_VIDEO_PARTNER', 'GOOGLE_ADS'];

export const LicenseStatus = {
  ENABLED: 'ENABLED',
  DISABLED: 'DISABLED'
} as const;
